module.exports = __webpack_public_path__ + "static/media/rajasthani.abe1f72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rajasthani.jpg
// module id = 204
// module chunks = 0